import { ProductHistoryService, ProductService } from 'application/product/services';
import { TableViewStore, BaseListViewStore } from "core/stores";
import { toDate } from 'core/utils';
import { action } from "mobx";
import _ from 'lodash';

class ProductHistoryListViewStore extends BaseListViewStore {
	constructor(rootStore) {
        const productHistoryService = new ProductHistoryService(rootStore.application.baasic.apiClient);
        let items = null;
        super(rootStore, {
			autoInit: true,
			name: 'product-history',
			routes: {
				preview: item =>{
                    this.setChildNavigationTitle(i => i.id === item.id, item => item.productName);
					const index = items.indexOf(items.find((i) => i.id === item.id));
					if(items[index + 1]){
						this.rootStore.routerStore.goTo(
							'master.app.main.product.product-history.preview',
							{ id: item.id, previousId: items[index + 1].id}
						);
					}
					else
					{
						this.rootStore.notificationStore.error("No previous value stored for comparison.");
					}
                },
			},
			actions: () => {
				return {
					find: async params => {
						const response = await productHistoryService.find(_.extend(params, {
							embed: 'Product,CoreUser'
						}));
						const responseData = _.extend(response.data, {
							item: _.map(response.data.item, (item => {
								return _.extend(
									item, {
										productName: item.product && item.product.itemId,
										coreUserName: item.coreUser && `${item.coreUser.lastName}, ${item.coreUser.firstName}`,
										date: item.dateCreated && toDate(item.dateCreated),
									}
								);
							}))
						});

						this.setTitle(params.productId);
						items = responseData.item;
						return responseData;
					}
				};
			},
		});

        this.productService = new ProductService(rootStore.application.baasic.apiClient);

        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: [
					{
						key: 'date',
						onClick: item => this.routes.preview(item),
						title: "PRODUCT_HISTORY.LIST.COLUMNS.DATE"
					},
					{
						key: 'productName',
						onClick: item => this.routes.preview(item),
						title: "PRODUCT_HISTORY.LIST.COLUMNS.PRODUCT"
					},
					{
						key: 'coreUserName',
						onClick: item => this.routes.preview(item),
						title: "PRODUCT_HISTORY.LIST.COLUMNS.CORE_USER"
					}
				],
			})
		);
    }

	@action.bound
	async setTitle(productId) {
		const productResponse = await this.productService.get(productId, null);
		const productName = productResponse.data && productResponse.data.itemId;

		this.rootStore.viewStore.setNavigationOptions({
			title: productName
		});
		
	}
}

export default ProductHistoryListViewStore;